<!-- On an affaire's cancellation card, the card's panel is this one's: no nested panel, « Modifier » in the card's header. -->
@if (bare()) {
  <ng-container [ngTemplateOutlet]="cards" />
} @else {
  <app-expansion-panel
    title="Informations de la demande de résiliation"
    i18n-title
  >
    <!--
      A direct child of the panel: content projection resolves its slot on the
      static template, so a button inside an @if would land in the body instead
      of the header. Hidden rather than removed for the same reason.
    -->
    <button
      expansionPanelHeaderActions
      type="button"
      class="lty-btn lty-btn-white lty-btn-sm cancellation-request-info__edit"
      [hidden]="!editable"
      (click)="onEdit()"
      i18n
    >
      Modifier
    </button>
    <ng-container [ngTemplateOutlet]="cards" />
  </app-expansion-panel>
}

<ng-template #cards>
  @if (details; as request) {
    <div class="cancellation-request-info__cards">
      <app-card>
        <div cardRows class="card__rows">
          <div class="card__row">
            <span class="card__label" i18n>Police à résilier</span>
            <span class="card__value">{{ value(request.policyNumber) }}</span>
          </div>
          <div class="card__row">
            <span class="card__label" i18n>Type d’assurance à résilier</span>
            <span class="card__value">{{ insuranceTypeLabel }}</span>
          </div>
          <div class="card__row">
            <span class="card__label" i18n>Méthode d’envoi</span>
            <span class="card__value">{{ sendMethodLabel }}</span>
          </div>
          <div class="card__row">
            <span class="card__label" i18n>Date de la lettre</span>
            <span class="card__value">{{ letterDate }}</span>
          </div>
          <div class="card__row">
            <span class="card__label" i18n>Date de résiliation</span>
            <span class="card__value">{{ cancellationDate }}</span>
          </div>
          @if (effectiveCancellationDate; as effectiveDate) {
            <div class="card__row">
              <span class="card__label" i18n
                >Date de résiliation effective</span
              >
              <span class="card__value">{{ effectiveDate }}</span>
            </div>
          }
        </div>
      </app-card>

      <app-card>
        <div cardRows class="card__rows">
          <div class="card__row">
            <span class="card__label" i18n>Nom de la compagnie</span>
            <span class="card__value">{{ value(request.insurer.name) }}</span>
          </div>
          <div class="card__row">
            <span class="card__label" i18n>Adresse</span>
            <span class="card__value">{{
              value(request.insurer.address)
            }}</span>
          </div>
          <div class="card__row">
            <span class="card__label" i18n>Email</span>
            <span class="card__value">{{ value(request.insurer.email) }}</span>
          </div>
          <div class="card__row">
            <span class="card__label" i18n>Téléphone</span>
            <span class="card__value">{{
              value(request.insurer.phoneNumber)
            }}</span>
          </div>
          <div class="card__row">
            <span class="card__label" i18n>Informations supplémentaires</span>
            <span class="card__value cancellation-request-info__comment">{{
              value(request.comment)
            }}</span>
          </div>
        </div>
      </app-card>
    </div>
  }
</ng-template>
